import { combineReducers } from 'redux';
import { KardiaRxIDTFPatient } from './kardiaRxIdtf/KardiaRxIDTFPatientsReducers';
import { KardiaRxCCTPatient } from './KardiaRxCCTPatient/KardiaRxCCTPatientsReducers';
import { KardiaRxCCTWorklist } from './kardiaRxCCTWorklist/KardiaRxCCTWorklistReducers';
import { KardiaRxIDTFEcgTable } from './kardiaRxIdtf/KardiaRxIDTFEcgTableReducers';
import { KardiaRxIDTFEcgConfirm } from './kardiaRxIdtf/KardiaRxIDTFEcgConfirmReducers';
import { KardiaRxCCTEcgTable } from './KardiaRxCCTPatient/KardiaRxCCTEcgTableReducers';
import { KardiaRxCCTPatientHistory } from './KardiaRxCCTPatientHistory/KardiaRxCCTPatientHistoryReducers';
// import { AppointmentNotifications } from './TeamSettings/TeamSettingsReducers';

export default combineReducers({
  kardiaRxIDTFPatients: KardiaRxIDTFPatient,
  kardiaRxCCTPatients: KardiaRxCCTPatient,
  kardiaRxCCTWorklist: KardiaRxCCTWorklist,
  kardiaRxIDTFEcg: KardiaRxIDTFEcgTable,
  kardiaRxCCTEcg: KardiaRxCCTEcgTable,
  IDTFEcgConfirm: KardiaRxIDTFEcgConfirm,
  kardiaRxCCTPatientHistory: KardiaRxCCTPatientHistory,
});



// WEBPACK FOOTER //
// ./src/views/state/index.js